import MainHeader        from "../../components/layout/MainHeader";
import MainSlider        from "../../components/layout/MainSlider";
import AboutPreview      from "../../components/about/AboutPreview";
import WhyChooseUs       from "../../components/home/WhyChooseUs";
import NeedConsultation  from "../../components/shared/NeedConsultation";
import SponsersForHomePage from "../../components/home/SponsorsForHomePage";
import ProjectsGallery   from "../../components/projects/ProjectsGallery";
import FaqSection        from "../../components/shared/FaqSection";
import BottomCtaBanner   from "../../components/shared/BottomCtaBanner";
import Footer            from "../../components/layout/Footer";

function Home() {
  return (
    <>
      <MainHeader />
      <MainSlider />
      <AboutPreview />
      <WhyChooseUs />
      <SponsersForHomePage />
      <NeedConsultation />
      <ProjectsGallery />
      <FaqSection />
      <BottomCtaBanner />
      <Footer />
    </>
  );
}

export default Home;
